<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<h1 class="block_114" id="id_Toc151366859">The Undulating Field</h1>
<p class="block_"> </p>
<p class="block_8"><span class="text_">(</span><i class="calibre2">My response</i><span class="text_">)</span></p>
<p class="block_"> </p>
<p class="block_2">A dull, dreary, and monotonous life, I never liked.</p>
<p class="block_2">The one I wished for was like an undulating field—challenging but victorious.</p>
<p class="block_2">Always staying up but never looking down on anything, human or animal.</p>
<p class="block_2">I had dreams, and their fulfilment was paramount to my being.</p>
<p class="block_2">What I had not bargained for was the world and its many faces.</p>
<p class="block_2">I had not known then, that undulating fields hardly bear any yields.</p>
<p class="block_2">I had not bargained on the constraints and limitations that the world grants.</p>
<p class="block_2">That the passage of life is controlled by time and waits for no one.</p>
<p class="block_2">Making a living, family, friends, and all must fit within constricted boundaries.</p>
<p class="block_"> </p>
<p class="block_2">A life like ‘an undulating field’ I achieved, but at the cost of my dreams.</p>
<p class="block_2">That may be the case, but I stayed in touch, and my aspirations lingered on.</p>
<p class="block_2">Those traits once acquired, stay and never lose their taste nor flavour.</p>
<p class="block_2">They did not fade away because all of it was inherent.</p>
<p class="block_2">A gift, a talent, a misdemeanour, an annoyance? I was once confused.</p>
<p class="block_2">I was loved, adored, encouraged, motivated, and applauded because of it.</p>
<p class="block_2">It also was the root of hatred and malice. I was bullied and jeered by some.</p>
<p class="block_2">But I was happiest then, with ‘my head in the clouds’, as my dad would say.</p>
<p class="block_2">No photo nor film could capture what his heart could discern and commit to memory.</p>
<p class="block_"> </p>
<p class="block_2">That was then, before responsibilities and accountability came to stay.</p>
<p class="block_2">There were family and friends and a living to earn and chores to be done.</p>
<p class="block_2">But times go by, nights turn into days, seasons change; nothing stays the same.</p>
<p class="block_2">Long-forgotten memories resurface, and so do hopes and dreams.</p>
<p class="block_2">Abandoned practices regain favour as priorities change, and new discoveries are made.</p>
<p class="block_2">It’s surprising how ingrained traits spring into action once evoked.</p>
<p class="block_2">How wonder and mystery return as if they had never left.</p>
<p class="block_2">But the beauty of it all is that opportunities arise that make it possible for us to pursue the realisation of our dreams.</p>
<p class="block_3" id="calibre_pb_6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_005.vue?1b2ef1f0